const existe = document.querySelector(".square");

if (existe) {
  let larguraDaTela = window.innerWidth;
  console.log(larguraDaTela);

  function randomValues() {
    anime({
      targets: ".square, .circle, .triangle",
      translateX: function () {
        return anime.random(
          larguraDaTela <= 425 ? -400 : -800,
          larguraDaTela <= 425 ? 400 : 800
        );
      },
      translateY: function () {
        return anime.random(-300, 300);
      },
      rotate: function () {
        return anime.random(0, 360);
      },
      scale: function () {
        return anime.random(0.2, 2);
      },
      duration: 5000,
      easing: "easeInOutQuad",
      complete: randomValues,
    });
  }

  randomValues();
}
